import { SMART_CONNECTOR_EXECUTION_STATUSES } from '__pages/SmartConnectors/constants';
import {
  ExecutionProgress,
  SmartConnectorMetaData,
} from '__pages/SmartConnectors/types';
import { TFunction } from 'react-i18next';

export const getExecutionProgressString = (
  progress: ExecutionProgress,
  metaData: SmartConnectorMetaData,
  t: TFunction
) => {
  const groupInProgressIndex = progress.findIndex(
    (group) =>
      group?.status === SMART_CONNECTOR_EXECUTION_STATUSES.in_progress &&
      group.steps?.length
  );

  if (groupInProgressIndex < 0) {
    return '';
  }

  const groupInProgress = progress[groupInProgressIndex];

  const groupStepInProgressIndex = groupInProgress.steps.findIndex(
    (step) => step.status === SMART_CONNECTOR_EXECUTION_STATUSES.in_progress
  );

  if (groupStepInProgressIndex < 0) {
    return '';
  }

  const groupStepInProgress = groupInProgress.steps[groupStepInProgressIndex];

  return t('({{step}} {{index}} is {{percent}}% complete)', {
    step: metaData.execution_flow?.group[groupInProgress.type] || 'WTF',
    index: groupStepInProgressIndex + 1,
    percent: groupStepInProgress?.percentage_complete || 0,
  });
};
